import { useEffect, useState } from "react";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

import useClubMemberRequirementsData from "../../../state/clubMemberRequirements/UseClubMemberRequirementsData";

import useBaseUsasClubData from "@usas/ui-web/state/clubBase/UseBaseUsasClubData";
import useNavRoutes from "@usas/ui-web/state/security/UseNavRoutes";

import { DEFAULT_ID } from "@usas/ui-web/utils/Constants";

const INITIAL_STATE = {
  pageErrorMessage: ''
};

const INITIAL_GRID_STATE = {
  orgRoleId: DEFAULT_ID,
  orgRoleOptions: [],
  gridData: [],
  totalClubMembers: 0
};

const useClubMemberRequirements = () => {
  const navigate = useNavigate();
  const { navRoutes } = useNavRoutes();
  const { baseUsasClubState } = useBaseUsasClubData();
  const { clubMemberRequirementsState, getClubMemberRequirements } = useClubMemberRequirementsData();
  const [gridState, setGridState] = useState(INITIAL_GRID_STATE);
  const [state, setState] = useState(INITIAL_STATE);

  const onReloadPageClicked = (e) => {
    e?.preventDefault();

    window.location.reload();
  };

  const onBackToClubInfoClicked = (e) => {
    e?.preventDefault();

    navigate(navRoutes.CLUB_INFO?.route);
  };

  const onOrgRoleFilterChanged = (orgRoleId) => {
    try {
      const newGridData = clubMemberRequirementsState.arrayData.filter((clubMember) => {
        if (orgRoleId === DEFAULT_ID) {
          return true;
        } else {
          return clubMember.orgRoleId === orgRoleId;
        }
      });

      setGridState({
        ...gridState,
        orgRoleId,
        gridData: newGridData.map((x) => { return { ...x, personRoleRequirementId: `${x.personId}-${x.orgRoleId}` } })
      });
    } catch (error) {
      setState({
        ...state,
        pageErrorMessage: error.message
      });
    }
  }

  useEffect(() => {
    async function loadClubMemberRequirements() {
      try {
        if (baseUsasClubState.isObjLoaded === true) {
          const getClubMemberRequirementsResult = await getClubMemberRequirements(baseUsasClubState.objData.orgUnitId);

          if (Array.isArray(getClubMemberRequirementsResult?.arrayData)) {
            const newGridData = getClubMemberRequirementsResult.arrayData.map((x) => { return { ...x, personRoleRequirementId: `${x.personId}-${x.orgRoleId}` } })

            setGridState({
              ...gridState,
              orgRoleOptions: getOrgRoleOptions(getClubMemberRequirementsResult.arrayData),
              gridData: newGridData,
              totalClubMembers: getClubMemberRequirementsResult.arrayData.length,
            })
          }
        }
      } catch (error) {
        setState({
          ...state,
          pageErrorMessage: error.message
        });
      }
    }
    loadClubMemberRequirements();
    // eslint-disable-next-line react-hooks/exhaustive-deps   
  }, [baseUsasClubState]);

  function getOrgRoleOptions(clubMembers) {
    const orgRoleOptions = [];

    if (Array.isArray(clubMembers)) {
      clubMembers.forEach((clubMember) => {
        if (clubMember.orgRoleId && orgRoleOptions.some((x) => x.id === clubMember.orgRoleId) === false) {
          orgRoleOptions.push({ id: clubMember.orgRoleId, name: clubMember.orgRoleName });
        }
      });
    }

    orgRoleOptions.sort((a, b) => a.name.localeCompare(b.name));
    orgRoleOptions.unshift({ id: DEFAULT_ID, name: '--' });

    return orgRoleOptions;
  }

  return {
    orgUnitId: baseUsasClubState.objData.orgUnitId,
    reportRouteName: 'CLUB_STAFF_REQUIREMENTS',
    isLoading: clubMemberRequirementsState.isArrayLoading,
    state,
    gridState,
    onReloadPageClicked,
    onBackToClubInfoClicked,
    onOrgRoleFilterChanged
  };
};

export default useClubMemberRequirements;